export enum SeatClass {
  Economy = "ECONOMY",
  PremiumEconomy = "PREMIUM_ECONOMY",
  ComfortEconomy = "COMFORT_ECONOMY",
  Business = "BUSINESS",
  First = "FIRST",
}

export interface SearchFlightsOpts {
  basicSearch: boolean;
  airline: string;
  flightNumber: string;
  numberOfFlights: number;
  seatClass: SeatClass;
  numberOfPassengers: number;
  departureAirport: string;
  arrivalAirport: string;
}

const defaultOpts: SearchFlightsOpts = {
  basicSearch: true,
  airline: "",
  flightNumber: "",
  numberOfFlights: 1,
  seatClass: SeatClass.Economy,
  numberOfPassengers: 1,
  departureAirport: "",
  arrivalAirport: "",
};

export class SearchFlights {
  private _airline: string;
  private _flightNumber: string;
  private _numberOfFlights: number;
  private _seatClass: SeatClass;
  private _numberOfPassengers: number;
  private _departureAirport: string;
  private _arrivalAirport: string;
  private _basicSearch: boolean;

  constructor(opts: Partial<SearchFlightsOpts> = {}) {
    const options = { ...defaultOpts, ...opts };
    this._airline = options.airline;
    this._flightNumber = options.flightNumber;
    this._numberOfFlights = options.numberOfFlights;
    this._seatClass = options.seatClass;
    this._numberOfPassengers = options.numberOfPassengers;
    this._departureAirport = options.departureAirport;
    this._arrivalAirport = options.arrivalAirport;
    this._basicSearch = options.basicSearch;
  }

  public toOpts(): SearchFlightsOpts {
    return {
      airline: this._airline,
      flightNumber: this._flightNumber,
      numberOfFlights: +this._numberOfFlights,
      seatClass: this._seatClass,
      numberOfPassengers: +this._numberOfPassengers,
      departureAirport: this._departureAirport,
      arrivalAirport: this._arrivalAirport,
      basicSearch: this._basicSearch,
    };
  }

  public get airline() {
    return this._airline;
  }

  public set airline(airline: string) {
    this._airline = airline;
  }

  public get flightNumber() {
    return this._flightNumber;
  }

  public set flightNumber(flightNumber: string) {
    this._flightNumber = flightNumber;
  }

  public get numberOfFlights() {
    return this._numberOfFlights;
  }

  public set numberOfFlights(numberOfFlights: number) {
    this._numberOfFlights = numberOfFlights;
  }

  public get seatClass() {
    return this._seatClass;
  }

  public set seatClass(seatClass: SeatClass) {
    this._seatClass = seatClass;
  }

  public get numberOfPassengers() {
    return this._numberOfPassengers;
  }

  public set numberOfPassengers(numberOfPassengers: number) {
    this._numberOfPassengers = numberOfPassengers;
  }

  public get departureAirport() {
    return this._departureAirport;
  }

  public set departureAirport(departureAirport: string) {
    this._departureAirport = departureAirport;
  }

  public set arrivalAirport(arrivalAirport: string) {
    this._arrivalAirport = arrivalAirport;
  }

  public get arrivalAirport() {
    return this._arrivalAirport;
  }

  public get basicSearch() {
    return this._basicSearch;
  }

  public set basicSearch(basicSearch: boolean) {
    this._basicSearch = basicSearch;
  }

  public sanitize(): SearchFlights {
    return new SearchFlights({
      airline: this._airline,
      flightNumber: this._flightNumber,
      numberOfFlights: Math.max(
        +this._numberOfFlights,
        defaultOpts.numberOfFlights,
      ),
      seatClass: this._seatClass,
      numberOfPassengers: Math.max(
        +this._numberOfPassengers,
        defaultOpts.numberOfPassengers,
      ),
      departureAirport: this._departureAirport,
      arrivalAirport: this._arrivalAirport,
      basicSearch: this._basicSearch,
    });
  }
}
